export const APPEND_HUBACCESS = 'APPEND_HUBACCESS';

export function appendHubAccess(hubAccess) {
    return { type: APPEND_HUBACCESS, hubAccess };
}